import { Injectable } from '@angular/core';
import {environment} from '../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {AlertService} from './alert.service';
import {catchError, map} from 'rxjs/operators';
import {Observable, of} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CrosscheckService {

  private apiUrl = environment.apiUrl + '/crosscheck';  // URL to web api

  constructor(private http: HttpClient, private alertService: AlertService) { }

  getDataResponse(memberId: number, accountIds: string, type: string, fromDate?: string, toDate?: string): Observable<any> {

    let url = this.apiUrl + `/${type}?id_member=${memberId}`;
    if(typeof accountIds !== 'undefined' && accountIds !== '') {
      url += `&id_account=${accountIds}`;
    }
    if (fromDate) {
      url += `&from_date=${encodeURIComponent(fromDate)}`;
    }
    if (toDate) {
      url += `&to_date=${encodeURIComponent(toDate)}`;
    }

    return this.http.get<any>(url)
      .pipe(
        map(response => {
            if (response && response.status === 'success') {
              return response.data;
            }
            return [];
          },
          catchError(this.handleError('cash', [])))
      );
  }

  Cash(memberId: number, accountIds: string, fromDate?: string, toDate?: string): Observable<any> {
    return this.getDataResponse(memberId, accountIds, 'cash', fromDate, toDate);
  }

  UcgRcg(memberId: number, accountIds: string, fromDate?: string, toDate?: string): Observable<any> {
    return this.getDataResponse(memberId, accountIds, 'ucg-rcg', fromDate, toDate);
  }

  Performance(memberId: number, accountIds: string, fromDate?: string, toDate?: string): Observable<any> {
    return this.getDataResponse(memberId, accountIds, 'performance', fromDate, toDate);
  }

  PerformanceContribution(memberId: number, accountIds: string, fromDate?: string, toDate?: string): Observable<any> {
    return this.getDataResponse(memberId, accountIds, 'performance-contribution', fromDate, toDate);
  }

  DriverPosition(memberId: number, accountIds: string, fromDate?: string, toDate?: string): Observable<any> {
    return this.getDataResponse(memberId, accountIds, 'drivers-position', fromDate, toDate);
  }

  Gia(memberId: number, accountIds: string, fromDate?: string, toDate?: string): Observable<any> {
    return this.getDataResponse(memberId, accountIds, 'gia', fromDate, toDate);
  }

  checkComputeFile(memberId: number, accountIds: string, fromDate?: string, toDate?: string, isRunCompute?: boolean): Observable<any> {
    let url = this.apiUrl + `/check-compute-file?id_member=${memberId}`;
    if (typeof accountIds !== 'undefined' && accountIds !== '') {
      url += `&id_account=${accountIds}`;
    }
    if (fromDate) {
      url += `&from_date=${encodeURIComponent(fromDate)}`;
    }
    if (toDate) {
      url += `&to_date=${encodeURIComponent(toDate)}`;
    }
    if (isRunCompute) {
      url += `&is_run_compute=1`;
    }
    return this.http.get<any>(url).pipe(
      catchError(this.handleError('checkComputeFile', null))
    );
  }

  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      this.alertService.error(`${error}`);
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}
